
import { supabase } from "@/integrations/supabase/client";
import { handleServiceError, withErrorHandling } from "../utils/errorHandling";
import { RECIPE_SEARCHES } from "@/constants/queryKeys";

/**
 * Service for querying search history
 */
export const searchQueryService = {
  /**
   * Get recent searches for the current user
   * @param limit Maximum number of searches to return
   * @returns Array of recent searches or empty array on error
   */
  getRecentSearches: withErrorHandling(
    async (limit: number = 10): Promise<any[]> => {
      // Get the current user
      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user?.id) {
        console.log("User not authenticated, returning empty search history");
        return [];
      }

      const { data, error } = await supabase
        .from('recipe_searches')
        .select('*')
        .eq('user_id', user.id) // Now properly matching UUIDs
        .order('created_at', { ascending: false })
        .limit(limit);
      
      if (error) {
        throw error;
      }
      
      return data || [];
    },
    "Failed to get recent searches"
  )
};
